import OrganizationIcon from '@mui/icons-material/People';

export default OrganizationIcon;
